import App from "@frog/source/models/App.js"
import Audio from "@frog/source/utility/Audio.js"
import Navigation from "@frog/source/models/Navigation.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"

export default {
    "slug": "teach",
    "title": "School of Hard Knocks",
    "subtitle": "A game for Ludum Dare 57",
    "firstChapterKey": "1",
    "player": require("./player.js").default,
    "chapters": {
        "1": require("./1").default,
        "2": require("./2").default,
        "3": require("./3").default,
        "4": require("./4").default,
        "5": require("./5").default,
    },
    "configuration": {
        "darkness": "none",
        "squigglevision": "world",
        "immeadiateLevelups": true,
        "preserveExperienceEvenAfterDeath": true,
    },
    "credits": [
        "Andrew Goodenough",
        "Anna Arkhipova",
        "Doc McPherson",
    ],
    "overworld": {
        // ...
    },
    "openingEvents": function() {
        return [
            {"func": () => Navigation.go("/games/teach/chapters/1")},
        ]
    },
    "audio": {
        // ...
    }
}
